<div class="dialog-container">
  <div class="header">
    <h2 class="title">editor settings</h2>
    <button mat-icon-button (click)="onCloseClick()">
      <mat-icon svgIcon="ak-close" />
    </button>
  </div>
  <mat-dialog-content class="edit-settings-container">
    <h3>editor languages</h3>
    <app-language-selector
      [selectedLanguages]="displayingLanguages()"
      (languageSelectionChanged)="onLanguageSelectionChange($event)"
    />
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button (click)="onCloseClick()">close</button>
    <button data-apply-button mat-flat-button color="primary" (click)="onApplyClick()">
      apply
    </button>
  </mat-dialog-actions>
</div>
